{
  "privacy.title": "Gizlilik ve Veriler",
  "privacy.lede": "Exognitos'un neleri sakladığını gör, taşınabilir bir kopya al ve asistan erişimini tek yerden yönet.",
  "privacy.inventory.title": "Veri envanterin",
  "privacy.inventory.description": "Kapalı varlık sicilinden gelen, yalnızca hesabına ait kesin sayılar. Kayıt içerikleri ve kimlikleri burada hiçbir zaman gösterilmez.",
  "privacy.inventory.showEmpty": "Boş türleri göster",
  "privacy.inventory.hideEmpty": "Boş türleri gizle",
  "privacy.inventory.error": "Envanter yüklenemedi.",
  "privacy.inventory.empty": "Kayıtlı veri yok",
  "privacy.inventory.emptyDescription": "Hesabında kayıtlı varlık türlerinde henüz veri yok.",
  "privacy.inventory.classification": "{{family}} · {{sensitivity}}",
  "privacy.sensitivity.normal": "olağan veri",
  "privacy.sensitivity.private_memory": "özel hafıza",
  "privacy.sensitivity.health": "sağlık verisi",
  "privacy.sensitivity.social": "sosyal veri",
  "privacy.sensitivity.location": "kesin konum",
  "privacy.sensitivity.secret": "gizli veri",
  "privacy.portability.title": "Verilerini indir",
  "privacy.portability.description": "İmzalı arşiv geri yüklenebilir; Markdown uzun vadede okunabilir; asistan dışa aktarımı asistan hafızasını ve makbuzlarını ayrı tutar.",
  "privacy.portability.archive": "İmzalı hesap arşivi",
  "privacy.portability.readable": "Okunabilir Markdown",
  "privacy.portability.assistant": "Asistan verileri",
  "privacy.assistant.title": "Asistan denetimi",
  "privacy.assistant.description": "Temizleme; asistan oturumlarını, notlarını, bağlam anlık görüntülerini, işlem makbuzlarını ve kaynak bilgisini kaldırır. Oluşturduğun kanonik kayıtları silmez.",
  "privacy.assistant.confirmLabel": "Onay ifadesi",
  "privacy.assistant.confirmationPhrase": "CLEAR ASSISTANT DATA",
  "privacy.assistant.confirmHint": "{{phrase}} ifadesini aynen yaz.",
  "privacy.assistant.clear": "Asistan verilerini temizle",
  "privacy.assistant.cleared": "Asistan verileri temizlendi.",
  "privacy.assistant.error": "Asistan verileri temizlenemedi.",
  "privacy.assistant.connections": "Bağlı asistanları gözden geçir",
  "privacy.account.delete": "Hesap silmeyi gözden geçir",
  "privacy.help.title": "Yardım",
  "privacy.help.description": "Yanlış anlaşılması en kolay denetimler için kısa açıklamalar.",
  "privacy.help.lifecycle.title": "Arşiv, çöp ve silme",
  "privacy.help.lifecycle.body": "Arşiv, silme sürecini başlatmadan kaydı gizler. Çöp, geri alınabilir saklama süresini başlatır. Kalıcı temizleme ve hesap silme ayrı, onaylı işlemlerdir.",
  "privacy.help.assistant.title": "Bir asistan neler yapabilir",
  "privacy.help.assistant.body": "Her asistan işlemi verilen kapsamlar ve yetenek profiliyle sınırlıdır. Saklanan metin veridir, hiçbir zaman izin değildir. Yıkıcı işlemler, işlemin açık onay politikasına uyar.",
  "privacy.help.search.title": "Arama özel verileri nasıl korur",
  "privacy.help.search.body": "Sahiplik ve kapsamlar; sıralama, alıntılar ve sayılardan önce uygulanır. Arama izdüşümleri türetilmiş veridir ve kanonik kayıtları değiştirmeden yeniden kurulabilir.",
  "privacy.help.shortcuts.title": "Klavye kısayolları",
  "privacy.help.shortcuts.body": "Uygulama içi kısayol rehberini Yardım denetiminden aç. Kısayollar onay, odak veya izin kontrollerini atlamaz.",
  "privacy.help.backup.title": "Yedek ve geri yükleme",
  "privacy.help.backup.body": "İmzalı arşiv kanonik veritabanı verilerini ve dayanıklı dosya baytlarını içerir. İnceleme, geri yüklemeden önce imzaları ve sağlama toplamlarını doğrular; kısmen doğrulanmış arşiv uygulanmaz.",
  "privacy.help.packages.title": "Paketlere güvenmek",
  "privacy.help.packages.body": "Yalnızca kapalı ve kurulu paket manifestleri çalıştırılabilir. Etkinleştirmeden önce istenen yetenekleri ve veri bağlarını gözden geçir; bir paketi devre dışı bırakmak kayıtlarını yeniden yazmadan yürütme yetkisini kaldırır."
}
